import { createContext, useContext, useEffect, useState } from "react";
import type { AppModel } from "./state/app";
import { useObserve } from "./state/observable";

export const AppContext = createContext<AppModel | null>(null);

/** 拿到 AppModel 并订阅它的变化 */
export function useApp(): AppModel {
  const app = useContext(AppContext);
  if (!app) throw new Error("AppContext missing");
  useObserve(app);
  return app;
}

/** 宽屏（电脑、平板横屏）：侧边栏常驻 */
export function useWide(): boolean {
  const query = "(min-width: 900px)";
  const [wide, setWide] = useState(() => matchMedia(query).matches);
  useEffect(() => {
    const m = matchMedia(query);
    const on = () => setWide(m.matches);
    m.addEventListener("change", on);
    return () => m.removeEventListener("change", on);
  }, []);
  return wide;
}

/** 每秒刷新一次（“思考中 · 6 秒”这类计时） */
export function useTicker(active: boolean, ms = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    const t = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(t);
  }, [active, ms]);
  return now;
}
